import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSFX } from 'js/hooks/useSFX';

// import icons
import IconInfo from 'js/components/icon/Icon.info';
import IconArrowRight from 'js/components/icon/Icon.arrow-right';

const transition = { duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] };

const AccordionItem = ({ id, expanded, setExpanded, title = '', content = '', callback, action = () => {} }) => {
  const { playSFX } = useSFX();
  const isOpen = id === expanded;
  return (
    <div className={'accordion__item' + (isOpen ? ' accordion__item--active' : '')}>
      <div
        className="accordion__header"
        onClick={() => {
          playSFX('button_tap');
          action();
          callback();
        }}
      >
        <IconInfo
          className="accordion__header__icon-info"
          onClick={(e) => {
            playSFX('button_tap');
            e.stopPropagation();
            e.preventDefault();
            setExpanded(isOpen ? false : id);
          }}
        />
        <div className="accordion__header__title">{title}</div>
        <IconArrowRight className="accordion__header__icon-arrow-right" />
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            className="accordion__content-container conatiner"
            key="menu"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: 'auto', transition: { delay: 0.3 } },
              collapsed: { height: 0, transition: { delay: 0.2 } },
            }}
            transition={transition}
          >
            <motion.div
              className="accordion__content"
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, transition: { delay: 0.5 } },
                collapsed: { opacity: 0 },
              }}
              transition={transition}
            >
              {content}
            </motion.div>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AccordionItem;
